// Внешний стор для браузерной стрелки «назад»: адаптер платформы в него пишет,
// BrowserBackButtonRenderer читает.

export type BackButtonSnapshot = {
  isVisible: boolean
}

let snapshot: BackButtonSnapshot = { isVisible: false }
let clickHandler: (() => void) | null = null
const listeners = new Set<() => void>()

function notify() {
  listeners.forEach((listener) => listener())
}

export function setBackButtonSnapshot(next: Partial<BackButtonSnapshot>) {
  snapshot = { ...snapshot, ...next }
  notify()
}

export function setBackButtonClickHandler(handler: (() => void) | null) {
  clickHandler = handler
}

export function triggerBackButtonClick() {
  clickHandler?.()
}

export function subscribeBackButton(listener: () => void) {
  listeners.add(listener)
  return () => listeners.delete(listener)
}

export function getBackButtonSnapshot(): BackButtonSnapshot {
  return snapshot
}
